import BaseExcelService from './BaseExcelService';

class UserExcelService extends BaseExcelService {
  getBaseUrl() {
    return '~/api/excel/user';
  }
}

export default new UserExcelService();
